import { Injectable } from '@angular/core';
import { INDRAApiService } from '@ibe.services/api.indra.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URL_BFM_BOOKING_AVAILABILITY_SEARCH,
		URL_BFM_BOOKING_AVAILABILITY_SEARCH_MULTICITY,
		MOCK_URL_AVAILABILITY_BOOKING_SEARCH,
		MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STOPOVER_BOTH,
		MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STOPOVER_OUTBOUND,
		MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STOPOVER_INBOUND,
		MOCK_URL_AVAILABILITY_BOOKING_SEARCH_MULTICITY,
		MOCK_STATUS,
		MOCK_URL_AVAILABILITY_BOOKING_SEARCH_211,
		MOCK_URL_AVAILABILITY_BOOKING_SEARCH_PAY_WITH_MILES,
		URL_BFM_BOOKING_AVAILABILITY_MULTICITY_PAGINATION,
		URL_BFM_BOOKING_AVAILABILITY_MULTICITY_SORT_BY,
		MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STAR_ALLIANCE,
		URL_BFM_BOOKING_AVAILABILITY_MULTICITY_FILTER_BY,
		URL_BFM_BOOKING_AVAILABILITY_FLEX_PRICER,
		MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STOPOVER_WAITLIST,
		URL_BFM_BOOKING_AVAILABILITY_RETRIEVE_MATRIX,
		MOCK_URL_BOOKING_AVAILABILITY_RETRIEVE_MATRIX} from '@ibe.config';

@Injectable({
	providedIn: 'root'
})
export class INDRABookingAvailabilityService {

	constructor(private api: INDRAApiService, private http: HttpClient) {
	}

	public INDRA_searchBookingAvailability(param: any): Observable<any> {
		if (MOCK_STATUS.BOOKING_AVAILABILITY_SEARCH) {
			let mockURL = MOCK_URL_AVAILABILITY_BOOKING_SEARCH;
			if (MOCK_STATUS.BOOKING_AVAILABILITY_SEARCH_211) {
				mockURL = MOCK_URL_AVAILABILITY_BOOKING_SEARCH_211;
			} else {
				if (param['payWithMiles'] == true && param['starAlliance'] == false) {
					mockURL = MOCK_URL_AVAILABILITY_BOOKING_SEARCH_PAY_WITH_MILES;
				} else if (param['payWithMiles'] == true && param['starAlliance'] == true) {
					mockURL = MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STAR_ALLIANCE;
				} else if (param['stopOverOutboundLocation'] && param['stopOverInboundLocation']) {
					mockURL = MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STOPOVER_BOTH;
				} else if (param['stopOverOutboundLocation']) {
					mockURL = MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STOPOVER_OUTBOUND;
				} else if (param['stopOverInboundLocation']) {
					mockURL = MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STOPOVER_INBOUND;
				}
			}
			return this.http.get<any>(mockURL);
		} else {
			if(param.payWithMiles){
				return this.api.INDRA_post<any>(`${URL_BFM_BOOKING_AVAILABILITY_SEARCH}?payWithMiles=${param.payWithMiles}&starAlliance=${param.starAlliance}`, param);
			} else {
				return this.api.INDRA_post<any>(`${URL_BFM_BOOKING_AVAILABILITY_SEARCH}?payWithMiles=false&starAlliance=false`, param);
			}
			
		}
	}

	public INDRA_searchBookingAvailabilityForMulticity(param: any): Observable<any> {
		// use mock for stopover-waitlist avalability
		// return this.http.get<any>(MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STOPOVER_WAITLIST);

		if (MOCK_STATUS.BOOKING_AVAILABILITY_SEARCH_MULTICITY) {
			return this.http.get<any>(MOCK_URL_AVAILABILITY_BOOKING_SEARCH_MULTICITY);
		} else {
			return this.api.INDRA_post<any>(URL_BFM_BOOKING_AVAILABILITY_SEARCH_MULTICITY, param);
		}
	}

	public INDRA_searchPaginationForMulticity(param: any): Observable<any> {
		if (MOCK_STATUS.BOOKING_AVAILABILITY_SEARCH_MULTICITY) {
			return this.http.get<any>(MOCK_URL_AVAILABILITY_BOOKING_SEARCH_MULTICITY);
		} else {
			return this.api.INDRA_get<any>(`${URL_BFM_BOOKING_AVAILABILITY_MULTICITY_PAGINATION}?first=${param.first}&last=${param.last}`);
		}
	}

	public INDRA_searchSortByForMulticity(param: any): Observable<any> {
		if (MOCK_STATUS.BOOKING_AVAILABILITY_SEARCH_MULTICITY) {
			return this.http.get<any>(MOCK_URL_AVAILABILITY_BOOKING_SEARCH_MULTICITY);
		} else {
			return this.api.INDRA_get<any>(`${URL_BFM_BOOKING_AVAILABILITY_MULTICITY_SORT_BY}?first=${param.first}&last=${param.last}&sortBy=${param.sortBy}`);
		}
	}

	public INDRA_searchFilteredBookingAvailabilityForMulticity(searchParam: any, param: any): Observable<any> {
		// to do... mock data
		const concatURL = `${URL_BFM_BOOKING_AVAILABILITY_MULTICITY_FILTER_BY}?first=${param.first}&last=${param.last}`;
		return this.api.INDRA_post<any>(concatURL, searchParam);
		// return this.api.INDRA_post<any>(URL_BFM_BOOKING_AVAILABILITY_MULTICITY_FILTER_BY, searchParam);
	}

	public INDRA_searchFlexPricerPremiumFlights(param: any): Observable<any> {
		return this.api.INDRA_post<any>(URL_BFM_BOOKING_AVAILABILITY_FLEX_PRICER, param);
	}

	public INDRA_retrieveMatrix(): Observable<any> {
		if (MOCK_STATUS.BOOKING_AVAILABILITY_MATRIX_PANEL) {
			return this.http.get<any>(MOCK_URL_BOOKING_AVAILABILITY_RETRIEVE_MATRIX);
		} else {
			return this.api.INDRA_post<any>(URL_BFM_BOOKING_AVAILABILITY_RETRIEVE_MATRIX, null);
		}
	}
}
